// @ts-nocheck
import React, { createRef } from "react";
import ProcedureBlock from "../../../../base/basicComponents/procedureBlock";
import TaskInformation from "../../../sections/taskInfoSections";
import PageHeader from "../../../commonComponents/pageHeaders/PageHeader";
import ReadOnlyProcedureFileSection from "../../../sections/procedureFileSections/readOnlyProcedureFileSection";
import ReadOnlySupportingFileSection from "../../../sections/supportingFileSections/readOnlySupportingFileSection";
import ActiveShareTaskReadOnly from "../../../sections/sharedTaskSections/activeShareTaskReadOnly";
import ProcedureDetailService from "../../../../service/procedureFile/ProcedureDetailService";
import styles from "../index.module.scss";
import ReadOnlyProcedureInformation from "../../../sections/procedureInfoSections/readOnlyProcedureInfoSection";
import ApproveChangePPOService from "../../../../service/changePPO/ApproveChangePPOService";
import ProcessBase from "../../../commonComponents/processBase";
import NormalSpin from "../../../../base/basicComponents/spin";
import StepService from "../../../../service/stepBase/StepService";
import CompleteStepBusinessType from "../../../../service/stepBase/completeStepBusinessType";
import ApproveChangePPOStepService from "../../../../service/changePPO/approveChangePPOStepService";
import { disableInteraction, enableInteraction } from "utils";

const procedureFileRef = createRef();
const supportingFileRef = createRef();
const procedureInfoRef = createRef();
export default class AssignPPOCompleted extends ProcessBase {
  constructor(props: any) {
    super(props);
    this.state = {
      loading: false,
      pageHeadState: {
        receiveDate: null,
        requestByName: null,
        procedureStepStatus: null,
      },
      procedureFileData: {
        procedureTableData: [],
        clientServerPath: null,
        savedInRadioValue: null,
      },
      supportingFileData: [],
      procedureInfoState: {
        procedureData: null,
        procedureInfoData: {},
        ppoList: [],
      },
      taskInformationData: [],
      shareTask: {
        mainTaskAccountId: null,
        procedureProcessID: null,
        reason: null,
        returnReasonLogs: null,
        shareTaskAccountId: null,
        shareTaskProcedureStepID: null,
        shareTasks: [],
        submitReasonLogs: null,
      },
      jbProcedureSavedIn: null,
    };
    // @ts-ignore
    this.taskID = this._getRoutingParam("ProcedureTaskId");
    // @ts-ignore
    this.procedureID = this._getRoutingParam("ProcedureID");
    // @ts-ignore
    this.procedureStepID = this._getRoutingParam("ProcedureStepID");
  }

  _showLoading = () => {
    disableInteraction();
    this.setState({ loading: true });
  };

  _hideLoading = async () => {
    await enableInteraction();
    this.setState({ loading: false });
  };

  /* function about adjust data when get data from api */
  handleDataNull = (file: any, key: any) => {
    if (file[key] === null) {
      if (key === "procedureFileID") {
        return 0;
      } else {
        return null;
      }
    } else {
      return file[key];
    }
  };

  setProcedureFileData = (result: any) => {
    if (result.procedureFolder !== null) {
      this.setProcedureTableData(result.procedureFolder);
      this.setState({
        procedureFileData: {
          savedInRadioValue:
            result.procedureFolder !== null
              ? result.procedureFolder.procedureSaveInCategoryID
              : null,
          clientServerPath:
            result.procedureFolder !== null ? result.procedureFolder.clientServerPath : "",
          // @ts-ignore
          procedureTableData: this.procedureTableData,
        },
        // @ts-ignore
        supportingFileData: this.supportingTableData,
        jbProcedureSavedIn:
          result.procedureFolder === null ? null : result.procedureFolder.jbProcedureSaveIn,
      });
    }
  };

  setShareTaskData = (result: any) => {
    if (result.shareTask === null || result.shareTask === undefined) {
      return;
    }

    this.setState({
      shareTask: result.shareTask,
    });
  };

  setSupportingFileData = (result: any) => {
    if (result.supportingFolder !== null) {
      this.setSupportingTableData(result);
      this.setState({
        // @ts-ignore
        supportingFileData: this.supportingTableData,
      });
    }
  };

  _getPrimaryProcedureOwnerStepItemSuccess = (response: any, flowDataResult: any) => {
    const result = { ...response, ...flowDataResult };
    const {
      reviceDate,
      requestByName,
      primaryProcedureOwner,
      procedureOwner,
      procedureNote,
      shareTask,
      applyPmpExcluded,
      procedureFolder,
      procedureStatusID,
      taskInfomation,
    } = result;
    this.setProcedureTableData(procedureFolder);
    this.setSupportingTableData(result);
    this.setState({
      pageHeadState: {
        receiveDate: this._formateDate(reviceDate),
        requestByName,
      },
      procedureInfoState: {
        ...this.state.procedureInfoState,
        procedureData: {
          primaryProcedureOwner: {
            primaryProcedureOwnerID: primaryProcedureOwner?.oldPrimaryProcedureOwnerID,
            primaryProcedureOwnerName: primaryProcedureOwner?.oldPrimaryProcedureOwnerName,
          },
          procedureOwner: procedureOwner,
          procedureNote,
        },
        procedureInfoData: {
          isExcluded: applyPmpExcluded?.isExcluded ? "Yes" : "No",
          procedureStatus: procedureStatusID,
          procedureNote,
        },
      },
      shareTask,
      procedureFileData: {
        savedInRadioValue:
          result.procedureFolder !== null ? result.procedureFolder.procedureSaveInCategoryID : null,
        clientServerPath:
          result.procedureFolder !== null ? result.procedureFolder.clientServerPath : "",
        // @ts-ignore
        procedureTableData: this.procedureTableData,
      },
      taskInformationData: taskInfomation,
      // @ts-ignore
      supportingFileData: this.supportingTableData,
      jbProcedureSavedIn:
        result.procedureFolder === null ? null : result.procedureFolder.jbProcedureSaveIn,
    });

    this._hideLoading();
  };

  _getPrimaryProcedureOwnerStepItemFailed = () => {
    this._alertError("Get Primary Procedure Owner Step Item Failed");
  };

  _getFlowDataSuccess = (result: any, param: any) => {
    const { procedureStepStatus } = result;
    let mergePayloadMap = undefined;

    StepService.setStepInterfaceMergePayload(result, {
      isShareTaskProcess: false,
      isHistorical: procedureStepStatus === "Complete",
      // @ts-ignore
      procedureStepId: this.procedureStepID,
      // @ts-ignore
      procedureTaskId: this.taskID,
    });

    if (procedureStepStatus === "Complete") {
      ApproveChangePPOStepService.getProcedureOwnerStepKey = () =>
        CompleteStepBusinessType.procedureOwner;
      ApproveChangePPOStepService.getPMPExcludedStepKey = () =>
        CompleteStepBusinessType.pmpExcluded;

      mergePayloadMap = StepService.getMergePayloadBySettingKey([
        CompleteStepBusinessType.procedureOwner.settingKey,
        CompleteStepBusinessType.pmpExcluded.settingKey,
      ]);
    }

    ApproveChangePPOService.getPrimaryProcedureOwnerStepItem(
      param,
      (response: any) => this._getPrimaryProcedureOwnerStepItemSuccess(response, result),
      this._getPrimaryProcedureOwnerStepItemFailed,
      undefined,
      {
        ...mergePayloadMap,
        ...StepService.getMergePayloadBySettingKey([CompleteStepBusinessType.taskInfo.settingKey]),
      }
    );
  };

  _getFlowDataFailed = () => {
    this._alertError("Get PPO Flow Data Failed");
  };

  getFlowData = () => {
    const parentPageData = this._getRoutingParam("ParentPage");
    const param = {
      // @ts-ignore
      taskID: this.taskID,
      // @ts-ignore
      procedureID: this.procedureID,
      // @ts-ignore
      procedureStepID: this.procedureStepID,
      parentPage: parentPageData,
    };

    ApproveChangePPOService.getFlowStepData(
      param,
      (response: any) => this._getFlowDataSuccess(response, param),
      this._getFlowDataFailed
    );
  };

  _getPrimaryProcedureOwnerDDLSuccess = (result: any) => {
    this.setState({
      procedureInfoState: {
        ...this.state.procedureInfoState,
        ppoList: result,
      },
    });
  };

  _getPrimaryProcedureOwnerDDLFailed = () => {
    this._alertError("Get Primary Procedure Owner Failed");
  };

  getPrimaryProcedureOwnerDDL = () => {
    // @ts-ignore
    ProcedureDetailService.getPrimaryProcedureOwnerDDL(
      this.taskID,
      this._getPrimaryProcedureOwnerDDLSuccess,
      this._getPrimaryProcedureOwnerDDLFailed
    );
  };

  componentDidMount() {
    this._showLoading();
    this.getFlowData();
    this.getPrimaryProcedureOwnerDDL();
  }

  render() {
    const { receiveDate, requestByName } = this.state.pageHeadState;
    const { procedureData, procedureInfoData, ppoList } = this.state.procedureInfoState;
    const { loading, taskInformationData, shareTask, jbProcedureSavedIn } = this.state;
    const { procedureTableData, clientServerPath, savedInRadioValue } =
      this.state.procedureFileData;
    const params = {
      // @ts-ignore
      TaskId: this.taskID,
      // @ts-ignore
      ProcedureID: this.procedureID,
      // @ts-ignore
      ProcedureStepID: this.procedureStepID,
    };

    return (
      // @ts-ignore
      <NormalSpin spinning={loading} size="large" zIndex={1500}>
        <div className={styles.body}>
          <div className={styles.header}>
            <PageHeader
              title="Change Primary Procedure Owner"
              receiveDate={this._formateDate(receiveDate)}
              requestBy={requestByName}
              status="Complete"
            />
          </div>
          <ProcedureBlock
            className={styles.approveProcedureBlock}
            child={<TaskInformation data={taskInformationData} />}
            isShowArrow={true}
            isOpen={false}
            testid="task-info-block-arrow"
            onShowDataLoad={() => {
              return StepService.getStepData(
                params,
                this.setTaskInfoData,
                this.setError,
                [CompleteStepBusinessType.taskInfo],
                StepService.getMergePayloadBySettingKey([
                  CompleteStepBusinessType.taskInfo.settingKey,
                ])
              );
            }}
          />
          <ProcedureBlock
            child={
              <ReadOnlyProcedureFileSection
                procedureFileData={procedureTableData}
                procedureFileRef={procedureFileRef}
                clientServerPath={clientServerPath}
                savedInRadioValue={savedInRadioValue}
                jbProcedureSavedIn={jbProcedureSavedIn}
              />
            }
            isShowArrow={true}
            isOpen={false}
            testid="procedure-file-block-arrow"
            onShowDataLoad={() => {
              return StepService.getStepData(
                params,
                this.setProcedureFileData,
                this.setError,
                [CompleteStepBusinessType.procedureFile],
                StepService.getMergePayloadBySettingKey([
                  CompleteStepBusinessType.procedureFile.settingKey,
                ])
              );
            }}
          />
          <ProcedureBlock
            child={
              <ReadOnlySupportingFileSection
                supportingFileRef={supportingFileRef}
                supportingFileData={this.state.supportingFileData}
              />
            }
            isShowArrow={true}
            isOpen={false}
            testid="supporting-file-block-arrow"
            onShowDataLoad={() => {
              return StepService.getStepData(
                params,
                this.setSupportingFileData,
                this.setError,
                [CompleteStepBusinessType.supportingFile],
                StepService.getMergePayloadBySettingKey([
                  CompleteStepBusinessType.supportingFile.settingKey,
                ])
              );
            }}
          />
          <ProcedureBlock
            className={styles.ProcedureInfoSection}
            child={
              // @ts-ignore
              <ReadOnlyProcedureInformation
                ref={procedureInfoRef}
                isShowActions={false}
                procedureData={procedureData}
                submitData={procedureInfoData}
                noteDisabled={true}
                isPPODisabled={true}
                title="Procedure Information"
                ppoList={ppoList}
              />
            }
            isShowArrow={true}
            isOpen={true}
            testid="procedure-info-block-arrow"
          />
          <ProcedureBlock
            className={styles.approveProcedureBlock}
            child={<ActiveShareTaskReadOnly shareTaskData={shareTask} />}
            isShowArrow={true}
            isOpen={false}
            testid="share-task-block-arrow"
            onShowDataLoad={() => {
              return StepService.getStepData(
                params,
                this.setShareTaskData,
                this.setError,
                [CompleteStepBusinessType.shareTask],
                StepService.getMergePayloadBySettingKey([
                  CompleteStepBusinessType.shareTask.settingKey,
                ])
              );
            }}
          />
        </div>
      </NormalSpin>
    );
  }
}
